<template>
  <v-content>
    <div class="auth-background"></div>
    <v-container fluid class="fill-height pa-0">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="11" md="10" lg="7" xl="5">
          <v-card
            color="transparent"
            elevation="10"
            :tile="isMobile"
            :flat="isMobile"
            :height="isMobile ? '100vh' : 600"
          >
            <v-row no-gutters class="fill-height">
              <v-col :cols="isMobile ? 12 : 8" sm="6" md="8" v-if="!isMobile">
                <v-card flat class="fill-height auth-content-a" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                  <v-card-title class="mb-5">
                    <v-img
                      contain
                      width="200"
                      height="200"
                      aspect-ratio="1"
                      transition="none"
                      :src="ossPath('/images/logos/logo-7.svg')"
                    ></v-img>
                  </v-card-title>
                  <v-card-title class="display-1 pa-0">{{ env.VUE_APP_BRAND_NAME }} - {{ env.VUE_APP_PLATFORM_NAME }}</v-card-title>
                  <v-card-title style="margin-bottom: 100px;">全国领先的网络货运平台</v-card-title>
                  <v-footer absolute color="transparent" class="pa-5 justify-center body-2">
                    <span class="mr-1">Copyright</span>
                    <v-icon class="mr-1 body-2" color="black">mdi-copyright</v-icon>
                    <span class="mr-1" v-text="'2004 - ' + new Date().getFullYear()"></span>
                    <a class="mr-1" href="https://www.yundangdang.com" target="_blank">运当当物流云提供技术支持</a>
                    <span>All Rights Reserved.</span>
                  </v-footer>
                </v-card>
              </v-col>
              <v-col :cols="isMobile ? 12 : 4" sm="6" md="4">
                <v-card flat class="fill-height auth-content-b" :tile="isMobile">
                  <v-toolbar flat color="grey lighten-5">
                    <v-toolbar-title>微信登录</v-toolbar-title>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text class="pa-5">
                    <router-view></router-view>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  export default {
    name: 'auth',
    data: () => ({
      env: process.env
    })
  }
</script>

<style lang="scss">
  @import '../../../plugins/ui/config';

  .auth-background {
    position: fixed;
    z-index: 0;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .auth-background:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: url($ossUrl + '/images/bg/0164175e128666a801216518a2c2b7.jpg@2o.jpg') no-repeat center center fixed;
    background-size: cover;
    filter: blur(3px);
    transform: scale(1.1);
  }
  .auth-content-a {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
  .auth-content-b {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
</style>
